import { z } from 'zod';
import { uuidSchema } from './common';

/**
 * 📎 Attachments — receipt/fatura/makbuz upload.
 * Dosya yükleme multipart üzerinden yapılır; bu schema metadata'yı tanımlar.
 */
export const attachmentMimeWhitelist = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif',
  'application/pdf',
] as const;

export type AttachmentMimeType = (typeof attachmentMimeWhitelist)[number];

export const linkAttachmentSchema = z.object({
  transactionId: uuidSchema,
});
export type LinkAttachmentInput = z.infer<typeof linkAttachmentSchema>;

export const updateOcrSchema = z.object({
  ocrText: z.string().max(50_000),
});
export type UpdateOcrInput = z.infer<typeof updateOcrSchema>;
